import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;
const BARRACUDA = process.env.BARRACUDA;

const report = {
    getReports(module) {
        return Axios.get(`${baseURL}report/reports`, {
            params: {
                module: module
            }
        }).then(response => (response ? response.data.response : []));
    },
    getReport(reportId, params) {
        return Axios.get(`${baseURL}report/reports/${reportId}`, {
            signal: params?.signal,
            params: params
        }).then(response => (response ? response.data.response : []));
    },
    getCustomReport() {
        return Axios.get(`${BARRACUDA}report/custom-reports`).then(
            response => response?.data?.response || []
        );
    },
    getRenderCustomReport(reportId, params) {
        return Axios.get(`${baseURL}report/render-custom-reports/${reportId}`, {
            params: params
        }).then(response => (response ? response.data.response : []));
    }
};
export default report;
